import React from 'react';
import { Link } from 'react-router-dom';
import './CTASection.css';

const CTASection = () => {
  return (
    <section className="section cta-section">
      <div className="container">
        <h2 className="section-title">
          Projeleriniz İçin Hazırız
        </h2>
        <p className="section-subtitle">
          Size en uygun çözümü birlikte bulalım. İletişime geçin ve projelerinizi hayata geçirelim.
        </p>
        <div className="cta-buttons">
          <Link to="/contact" className="btn cta-btn-primary">
            İletişime Geç
          </Link>
          <Link to="/services" className="btn btn-outline cta-btn-outline">
            Hizmetlerimiz
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;

